import React from 'react';
import './App.css';
import Questionnaire from './components/Questionnaire';
import PostPurchase from './components/PostPurchase';
import September from './components/September';
import ErrorBoundary from './ErrorBoundary';

// Ingen router. Firebase har en catch-all rewrite til index.html, så enhver
// sti rammer denne komponent, og stien afgør hvilket skema der vises.
// Alt der ikke matcher er købsflowets spørgeskema, inklusive /en.
// Produktundersøgelsen ligger på /research. /september nåede at blive delt
// under opbygningen og omdirigeres i firebase.json — uden den omdirigering
// ville et gammelt link lande på købsflowets skema, hvilket er værre end
// ingenting.
const RUTER = [
  { test: /^\/post-purchase(\/|$)/i, komponent: PostPurchase },
  { test: /^\/research(\/|$)/i, komponent: September },
];

function App() {
  const sti = window.location.pathname;
  const rute = RUTER.find(r => r.test.test(sti));
  const Skema = rute ? rute.komponent : Questionnaire;

  return (
    <div className="App">
      <ErrorBoundary>
        <Skema />
      </ErrorBoundary>
    </div>
  );
}

export default App;
